import React from 'react'
import { withRouter } from 'react-router'

import { RequestContextProps } from 'src/lib/js/context'
import { t, Trans } from 'src/translations'
import { isPreviewSite } from 'src/lib/js/previewModeUtils'
import { useStaticSiteContext } from 'src/public/components/app/StaticSiteContext'

import Button from 'shared/components/common/button'
import Link from 'shared/components/common/link'
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useModal
} from 'shared/components/common/modal'
import { NavType } from 'shared/components/common/nav/Nav'
import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'

type Props = RequestContextProps & {
  navType: NavType
  shouldShowPreviewBanner: boolean
  className?: string
}

const PreviewModeBanner = (props: React.PropsWithChildren<Props>) => {
  const { isOpen, onClose, onOpen } = useModal()
  const { restaurant, toastProduct } = useRestaurant()
  const staticContext = useStaticSiteContext()
  const isPreviewMode = isPreviewSite(
    staticContext,
    restaurant?.config,
    toastProduct
  )

  return (
    <>
      {props.shouldShowPreviewBanner && isPreviewMode && (
        <>
          <div className='previewModeBanner'>
            <p>{t('preview-mode-banner.this-website-is-in-preview-mode')}</p>
            <Button color={'#E7EAF6'} onClick={() => onOpen()}>
              {t('preview-mode-banner.more-info')}
            </Button>
          </div>
          <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay fadeIn fadeOut />
            <ModalContent
              contentClassName='previewModeModalContent'
              slideIn
              slideOut
              data-testid='PreviewModeModal'
              ariaLabelledBy={'preview-mode-modal'}
            >
              <div className='modalHeader'>
                <h3 className='header' id='preview-mode-modal' tabIndex={-1}>
                  {t(
                    'preview-mode-banner.this-website-is-currently-in-preview-mode'
                  )}
                </h3>
                <ModalCloseButton />
              </div>
              <div>
                <p>
                  {t(
                    'preview-mode-banner.while-in-preview-mode-site-cannot-be-indexed'
                  )}
                </p>
                <br />
                <p>
                  <Trans
                    i18nKey='preview-mode-banner.you-can-bring'
                    components={{
                      Link: (
                        <Link href='https://www.toasttab.com/restaurants/admin/sites/dashboard/' />
                      )
                    }}
                  />
                </p>
              </div>
            </ModalContent>
          </Modal>
        </>
      )}
    </>
  )
}

export default withRouter(PreviewModeBanner)
